export const omitNilEntries = <A extends {}>(
  obj: A
):
  | { [K in keyof A]: A[K] extends NonNullable<A[K]> ? A[K] : never }[keyof A]
  | {} =>
  Object.entries(obj).reduce(
    (acc, [k, v]) => (v != null ? { ...acc, [k]: v } : acc),
    {}
  );
